import styled, { css } from "styled-components";
import { IMenuProps, ITabProps } from "./interfaces";

export const Menu = styled.div<IMenuProps>`
    overflow-x: auto;
    white-space: nowrap;
    ${p =>
        !p.noBorderBottom &&
        css`
            border-bottom: solid 1px ${p => p.theme.c.greyD};
        `}
    &.Expand {
        display: flex;
    }
`;

export const Tab = styled.div<ITabProps>`
    display: inline-block;
    color: ${p => p.theme.c.grey7};
    padding: 8px 0;
    margin: 4px 8px 0;
    cursor: pointer;
    font-size: 14px;
    &.Lg {
        font-size: 18px;
    }
    font-weight: 600;
    ${p =>
        p.$titleMinWidth &&
        css`
            min-width: ${p.$titleMinWidth}px;
        `}

    &.Active {
        color: ${p => p.theme.c.boost};
        border-bottom: 3px solid ${p => p.theme.c.boost};
    }

    &.Expand {
        text-align: center;
        flex: 1;
    }

    &.Dark {
        color: ${p => p.theme.c.pale};
    }
    &.Dark.Active {
        color: ${p => p.theme.c.light};
        border-bottom: 3px solid ${p => p.theme.c.light};
    }
`;

export const Display = styled.div`
    transition: height 500ms, opacity 500ms;
`;
